/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  OrderCartResponseData,
  OrderCartResponseDataFromJSON,
  OrderCartResponseDataFromJSONTyped,
  OrderCartResponseDataToJSON,
} from './';

/**
 *
 * @export
 * @interface OrderCartResponse
 */
export interface OrderCartResponse {
  /**
   *
   * @type {string}
   * @memberof OrderCartResponse
   */
  message: string;
  /**
   *
   * @type {OrderCartResponseData}
   * @memberof OrderCartResponse
   */
  order: OrderCartResponseData;
}

export function OrderCartResponseFromJSON(json: any): OrderCartResponse {
  return OrderCartResponseFromJSONTyped(json, false);
}

export function OrderCartResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): OrderCartResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    message: json['message'],
    order: OrderCartResponseDataFromJSON(json['order']),
  };
}

export function OrderCartResponseToJSON(value?: OrderCartResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    message: value.message,
    order: OrderCartResponseDataToJSON(value.order),
  };
}
